import { shallowEqual } from 'react-redux'
import { useFormSelector } from './formStoreHooks'
import _ from 'lodash'
import { FormRootState } from './formStore'

export const selectAllConceptStatuses = (state: FormRootState) =>
	state.form.conceptStatus

export const selectConceptStatus = (state: FormRootState, cid?: string) =>
	cid ? state.form.conceptStatus[cid] : null

export const useConceptStatus = (cid?: string) =>
	useFormSelector(state => selectConceptStatus(state, cid))

export const selectConceptStatuses = (state: FormRootState, cids: string[]) =>
	_.pick(state.form.conceptStatus, cids)

// avoid re-rendering the control
// if none of the applicable conceptStatuses have changed
// see selectConceptStatus2.test.js for validation
export const useConceptStatuses = (cids: string[]) => 
	useFormSelector(state => selectConceptStatuses(state, cids), shallowEqual)

export const selectConceptStatusValidity = (state: FormRootState, cid?: string) =>
	cid ? state.form.conceptStatusValidity[cid] : null

export const useConceptStatusValidity = (cid?: string) =>
	useFormSelector(state => selectConceptStatusValidity(state, cid))
